((window, $) => {
  const doc = window.document;
  const personalInfoForm = doc.getElementById('personal-info-form');
  if (personalInfoForm) {
    const firstName = $('#personal-info-form-first-name');
    const firstNameValid = $('#validation-personal-info-form-first-name');
    const lastName = $('#personal-info-form-last-name');
    const lastNameValid = $('#validation-personal-info-form-last-name');
    const address = $('#personal-info-form-address');
    const addressValid = $('#validation-personal-info-form-address');
    const city = $('#personal-info-form-city');
    const cityValid = $('#validation-personal-info-form-city');
    const zipCode = $('#personal-info-form-zip-code');
    const zipCodeValid = $('#validation-personal-info-form-zip-code');
    const stateInput = $('#personal-info-form-state-input');
    const stateValid = $('#validation-personal-info-form-state');
    const stateList = $('#personal-info-form-state-list');
    const country = $('#personal-info-form-country');
    const saveBtn = $('#personal-info-form-save-changes');
    const saveBtnSpinner = $('#personal-info-form-save-changes span');
    const disableValidBlock = (element) => {
      element.removeClass('d-block');
      element.addClass('d-none');
    };
    const visableValidBlock = (element) => {
      element.removeClass('d-none');
      element.addClass('d-block');
    };
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.suggestion-container')) {
        disableValidBlock(stateList);
      }
    });
    stateInput.on('input', function () {
      const inputValue = this.value.toLowerCase().trim();
      if (inputValue) {
        stateList.children().each(function (index, element) {
          const $element = $(element);
          if ($element.text().toLowerCase().includes(inputValue)) {
            visableValidBlock($element);
          } else {
            disableValidBlock($element);
          }
        });
        visableValidBlock(stateList);
      } else {
        disableValidBlock(stateList);
      }
    });
    stateList.on('click', (e) => {
      stateInput.val($(e.target).text());
      disableValidBlock(stateValid);
      disableValidBlock(stateList);
    })
    const activeValidBlock = (element, textError) => {
      element.removeClass('d-none');
      element.addClass('d-block');
      let text = '';
      textError.forEach((error) => {
        text = `${text} ${error}`;
      });
      element.text(text);
    };
    const deleteInvalidClass = (element) => {
      element.removeClass('is-invalid');
    };
    const activeInvalidClass = (element) => {
      element.addClass('is-invalid');
    };
    const disableAllErrors = () => {
      deleteInvalidClass(firstName);
      disableValidBlock(firstNameValid);
      deleteInvalidClass(lastName);
      disableValidBlock(lastNameValid);
      deleteInvalidClass(address);
      disableValidBlock(addressValid);
      deleteInvalidClass(city);
      disableValidBlock(cityValid);
      deleteInvalidClass(stateInput);
      disableValidBlock(stateValid);
      deleteInvalidClass(zipCode);
      disableValidBlock(zipCodeValid);
    };
    const successSavePersonalInfoFn = () => {
      saveBtnSpinner.addClass('d-none');
      $('#wm-menu-dropdown-user span').text(firstName.val());
      const clientName = `${firstName.val()} ${lastName.val()}`;
      $('#top-user-menu h4').text(clientName);
    };
    const errorSavePersonalInfoFn = (error) => {
      saveBtnSpinner.addClass('d-none');
      if (error.status === 422) {
        const { data } = error.responseJSON;
        const keys = Object.keys(data);
        keys.forEach((key) => {
          switch (key) {
            case 'first_name':
              activeInvalidClass(firstName);
              activeValidBlock(firstNameValid, data.first_name);
              break;
            case 'last_name':
              activeInvalidClass(lastName);
              activeValidBlock(lastNameValid, data.last_name);
              break;
            case 'street':
              activeInvalidClass(address);
              activeValidBlock(addressValid, data.street);
              break;
            case 'city':
              activeInvalidClass(city);
              activeValidBlock(cityValid, data.city);
              break;
            case 'state':
                activeInvalidClass(stateInput);
                activeValidBlock(stateValid, data.state);
              break;
            case 'zipcode':
              activeInvalidClass(zipCode);
              activeValidBlock(zipCodeValid, data.zipcode);
              break;
            default:
              console.log(`Unknown field ${key}`);
          }
        });
      } else {
        console.log('Unexpected error when saving personal data.');
      }
    };
    saveBtn.on('click', (event) => {
      event.stopPropagation();
      event.preventDefault();
      saveBtnSpinner.removeClass('d-none');
      disableAllErrors();
      $.ajax({
        url: '/api/v1/customer/update',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          first_name: firstName.val(),
          last_name: lastName.val(),
          address: address.val(),
          city: city.val(),
          zip_code: zipCode.val(),
          state: stateInput.val(),
          country: country.val(),
        }),
        success: () => successSavePersonalInfoFn(),
        error: error => errorSavePersonalInfoFn(error),
      });
    });
  }
})(window, window.jQuery);
